import MDB from '../marketingdb';

const copy = (input) => MDB.copyToClipboard(input);

export {
    copy
};